export default "__VITE_ASSET__CfCTFNCG__"